var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff47ae"
    },
    d: "M509.538,323.166l-62.06-124.12c-3.941-7.885-11.999-12.864-20.815-12.864 c-8.816,0-16.874,4.98-20.815,12.864L336.235,338.27l-80.234-206.319l-9.342-24.022c-3.385-8.702-11.642-14.541-20.976-14.826 c-9.267-0.285-17.932,5.03-21.845,13.509l-86.851,188.175H23.273C10.42,294.788,0,305.208,0,318.06 c0,12.853,10.42,23.272,23.273,23.272h108.605c9.078,0,17.327-5.278,21.13-13.52l70.129-151.946l32.862,84.506l55.882,143.698 c3.336,8.58,11.416,14.386,20.612,14.812c0.362,0.017,0.723,0.025,1.083,0.025c8.78,0,16.857-4.956,20.81-12.865l72.277-144.55 l41.245,82.489c5.747,11.497,19.726,16.157,31.222,10.408C510.627,348.642,515.286,334.663,509.538,323.166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff4747"
    },
    d: "M246.659,107.929c-3.385-8.702-11.642-14.541-20.976-14.826c-9.267-0.285-17.932,5.03-21.845,13.509 l-86.851,188.175H23.273C10.42,294.788,0,305.208,0,318.06c0,12.853,10.42,23.272,23.273,23.272h108.605 c9.078,0,17.327-5.278,21.13-13.52l70.129-151.946l32.862,84.506V131.951L246.659,107.929z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphRed);
export default __webpack_public_path__ + "static/media/graphRed.53273377d6935c1bf3a31bb003c27c62.svg";
export { ForwardRef as ReactComponent };